module.exports =  {
  hotel: {
    BOOKING_NOW: '立即预订',
    Book_Hotel: '预订酒店',
    Select_your_destination: '请选择目的地',
    Please_enter_your_destination: '请输入目的地/酒店',
    Booked_up: '已订完',
    Hotel_description: '酒店介绍',
    Check_in_date: '入住日期',
    Check_out_date: '退房日期',
    Sold_out: '售完',
    Non_refundable: '不可取消',
    reserve: '订',
    Pay_Online: '在线付',
    Only_rooms_left_before: '还剩',
    Only_rooms_left_after: '间',
    Cancellation_Policy: '取消政策',
    See_all_prices_before: '查看全部',
    See_all_prices_after: '个价格',
    Estimated_time_of_arrival: '预计到店',
    make_your_schedule_well_planned: '为当地时间，选定后请合理安排出行。',
    Hotel_Not_Found: '未找到所选条件的酒店',
    Please_change_your_search: '请修改条件重新查询',
    Submit_an_application: '提交申请',
    Hotel_Confirmation: '酒店确认',
    Many_Night_Stay_before: '入住',
    Many_Night_Stay_after: '晚',
    Hotel_Booking_Number: '酒店预约号',
    Online_Payment: '在线支付',
    The_guest_Room_before: '入住人',
    The_guest_Room_after: '】',
    Contact_number: '联系号码',
    Bring_all_valid_IDs: '入住时请携带所有入住人的有效身份证件。',
    Hotels_Found_before: '搜索到',
    Hotels_Found_after: '家酒店',
    Hotels_Presented_before: '当前显示',
    Hotels_Presented_center: '家酒店(共',
    Hotels_Presented_after: '家)',
    Please_change_the_dates: '没有查询到所选日期的房型，请重新选择住宿日期。',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '共',
    Nights_in_total_after: '晚',
    Location: '酒店位置',
    Pictures: '酒店图片',
    Description: '酒店介绍',
    Policy: '酒店政策',
    Check_in_and_check_out_time: '入离时间',
    Check_in_and_Check_out_before: '入住时间：',
    Check_in_and_Check_out_center: '以后  离店时间：',
    Check_in_and_Check_out_after: '以前',
    Check_in_time: '入住时间',
    Check_out_time: '离店时间',
    Hotel_Information: '基本信息',
    Opening_Date: '开业时间',
    Renovation_Date: '装修时间',
    Facility_Service: '设施服务',
    Payment_methods: '酒店接受的支付方式',
    Hotel_Address: '酒店地址',
    Pay_online: '在线支付',
    Pay_offline: '线下支付',
    Night_stay_before: '入住',
    Night_stay_after: '晚,',
    Rooms_total_before: '间共',
    Rooms_total_after: '',
    Guest_name_must_be_provided: '入住人姓名必须填写完整',
    Please_fill_in_your_contact_number: '请输入联系号码',
    Select_estimated_time_of_arrival: '请选择预计到店时间',
    Number_of_Rooms: '房间数量',
    Maximum_guests_per_room_before: '每间最多入住',
    Maximum_guests_per_room_after: '人',
    Many_Rooms: '间',
    Service_Fee_Included: '(含税和服务费)',
    Last_Name: '姓氏拼音',
    First_Name: '名字拼音',
    Room: '房间',
    Additional_Tax: '另付税费',
    Please_inform_the_hotel: '若超过登记的预计到店时间，请务必联络住宿酒店。',
    Please_inform_the_hotel_first: '没有提前与酒店联络，导致超过最迟入住时间时，房间或晚餐安排会有影响，请注意提前确认。',
    Booking_Cancellation: '取消订单',
    Reason_of_Cancellation: '取消原因',
    Incorrect_Information_Filled: '信息填错',
    Itinerary_Changed: '行程改变',
    Lower_price_on_other_APP: '其他APP更便宜',
    Low_quality_hotel: '酒店质量差',
    Book_at_a_lower_price: '前台预订更实惠',
    Other: '其他',
    Please_write_your_reason: '请填写原因',
    After_cancellation_done: '取消成功后，款项将会在3个工作日退回到您的原支付方。',
    How_to_fill_in_the_guest_name: '入住人填写说明',
    It_should_be_exactly_the_same: '预订酒店必须填写入住人的姓名，以英文字母填写。需与入住时所持证件完全一致。',
    How_to_fill_in_a_Chinese_name: '中文姓名填写方法：',
    How_to_fill_in_a_English_name: '英文姓名填写方法：',
    For_example: '例如：“韩梅梅”，姓填写“Han”，名填写“Meimei”',
    No_specical_characters: '① 英文姓名中不能包含数字或特殊符号',
    Name_rule_first: '② 姓在前，名在后，如有中间名则空一格紧随名之后。',
    Name_rule_second: ' 例如：Green / Jim Stephanie',
    Details: '明细',
    Pay_now: '立即支付',
    Hotel: '酒店',
    Check_in: '入住：',
    Car: '租车',
    All_bookings: '全部订单',
    All: '全部',
    the_real_scene: '图片仅供参考，请以实际入住酒店为准',
    COUPON_TXT: '优惠券',
    SHEET: '张',
    NONE_USE_TEXT: '暂无可用',
    USE_COUPON: '使用优惠券',
    BINDING_COUPON: '绑定新券',
    DESELECT_COUPON: '取消选择优惠劵',
    AVAILABLE: '可用',
    NO_COUPON_AVALIABLE: '暂无可用的优惠券',
    UNAVAILABLE: '不可用',
    NOT_ACTIVE: '未生效',
    COUPON_TO_BINDING: '绑定优惠券',
    WRITE_PREFERETIAL_CODE: '请输入优惠码',
    BINDING_USE: '绑定并使用',
    HAS_DEDUCTED_BEFORE: '已减',
    HAS_DEDUCTED_AFTER: '',
    PERSON_COUNT: '人',

    NAME_TXT: '姓名',
    HOLDER_NAME: '持卡人姓名',
    EXPIRATION_DATE: '到期日',
    FORMAT_TXT: '格式',
    SECURITY_CODE: '安全码',
    MASTER_CARD_NAME: '万事达卡',
    JCB_CARD_NAME: '日财卡',
    DIGITS_ON_BACK_OF_CARD: '卡片背后的3位数字。',
    AMERICAN_EXPRESS_NAME: '美国运通',
    FOUR_CAR_NUM_TIPS: '卡片正面的4位数',
    ENTER_COMPLETE_CARD_NUM: '请输入完整卡号',
    PLEASE_ENTER_HOLDER_NAME: '请输入持卡人姓名',
    ENTER_SECURITY_CODE: '请输入安全码',
    ENTER_EXPIRATION_DATE: '请输入到期日',
    ROOM_DETAILS: '客房详情',
    CONDITION_CANCEL: '条件取消',
    CHOOSE_PAYMENT_METHOD: '选择支付方式',
    ORDER_TOTAL_LUMP: '订单总额',
    CREDIT_CARD_NUM: '借记卡/信用卡号',
    MAINLAND_CARD_ONLY: '仅限中国大陆以外地区发行的银行卡',
    SHUT_DOWN: '关闭',

    SELECT_COUNTRY_CODE: '选择国家或地区',
    HOT_COUNTRY_OR_AREA: '热门国家/地区',
    EVAL_LIST_NO_DATA: '暂无数据',


    // 酒店搜索改版新增翻译
    PREFIX_ROOMS: '',
    SUFFIX_ROOM: '间',
    SUFFIX_ROOMS: '间',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: '成人',
    SUFFIX_ADULTS: '成人',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: '儿童',
    SUFFIX_CHILDREN: '儿童',
    ROOM: '客房',
    AGE: '岁',
    AGES: '岁',
    SELECT_ROOMS_TIPS: '请提供所有入住儿童的年龄，以便我们为您找到最合适的房型、床型。',
    CHECK_IN_DETAIL: '入住详情',
    CHILD_AGE: '儿童年龄',
    FILTER_CONDITION: '您的筛选条件是：',
    NO_MATCH_TIPS: '以下客房不符合“间数”、“人数”筛选条件',
    ROOM_COUNT: '间数',
    GUESTS: '人数',
    NO_MATCH_HOTEL: '以下为不符合筛选条件的酒店',

    TAXES_INCL: '含税总价',
    BOOK_TIMEOUT_TIPS: '页面超时，请返回酒店详情页刷新预订。 价格和空房情况可能在这段时间有变动。',
    LIST: '列表',
    RENT_CAR_BOOK: '预订',
    HOTEL_STR: '详情',
    SETTLEMENT_DETAIL: '住客详情',
    CONTACT_NAME: '联系人姓名',
    COUNTRY_CODE: '国家/地区代码',
    PHONE_NUMBER: '手机号码',
    TRAVEL_PHONE_NUMBER: '请输入联系人姓名',
    PLEASE_SELECT_AREA_CODE: '请选择国家/地区代码',

    Search: '搜索',
    COST_DESCRIPTION: '费用明细',
    TOTAL: '合计',
    SEE_ORDER_INFO_TO: '支付',
    KONW: '知道了',
    BOOKING_INFORMATION: '预订须知',
    Book_Now: '立即支付',
    MAP: '地图',
    CONTACT_INFORMATION: '联系方式',
    LOADING: '加载中...',
    SORT_FILTER: '排序/筛选',
    SCREENING: '筛选',
    SEQUENCE: '排序',
    PHONE_ASK: '电话咨询',
    ABOVE: '起',
    SUBMINT_ORDER: '提交订单',
    OK: '确定',
    Order_detail: '订单明细',
    BOOKING_INFO: '订单信息',
    PAYMENT_AMOUNT: '订单金额',
    Order_time: '下单时间',
    ORDER_NUMBERS: '订单号',
    PAY_TYPE: '支付方式',
    BALANCE: '账户余额',
    CURRENT_BALANCE_BEGIN: '当前余额',
    OVERPLUS_BALANCE_BEGIN: '结余',
    OTHER_PAYMENT: '其他支付方式',
    Unionpay: '银联支付',
    Wechatpay: '微信支付',
    Alipay: '支付宝支付',
    AGREE_SERVICE_AGREEMENT_BEFORE: '点击“立即支付”即表示您同意百高',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《服务协议》',
    PAYMENT_ORDER: '支付订单',
    Total_pay: '应付总额',
    PAY_SUCCESS: '支付成功',
    CHECK_THE_ORDER: '查看订单',
    BACK_TO_INDEX: '返回首页',
    CANCEL: '取消',
    RECOMMED: '推荐',
    PRICE: '价格',
    HIGH: '高',
    LOW: '低',
    RESET: '重置',
    SELECT_TIME: '选择日期',
    Hotel_guest: '入住人',
    Select: '请选择',
    Emial_address: '请输入邮箱地址',
    Booking_explan: '预订说明',
    VIEW_MORE: '查看更多',
    COLLAPSE: '收起',
    Week: '周',
    Month: '月',
    TOURISM_CHECK_IN_HOTEL: '入住',
    TOURISM_LEAVE_HOTEL: '离店',
    SUBMIT: '提交',
    EMAIL: '邮箱地址',
    BOOK_FAIL: '预订不成功',
    BOOK_FAIL_DETAIL: '哎呀…预订不成功，请您重新预订吧！',
    RESET_BOOK: '重新下单',
    ROOM_TYPE_LOADING_TIPS: '正在为您搜索房型价格,请稍等…',
    NEARBY_HOTEL: '附近酒店',
    HOT_CITY: '热门城市',

    SEARCH_HISTORY: '搜索历史',
    BREAKFAST_INCLUDE: '含餐',
    BREAKFAST_EXCLUDE: '不含餐',
    DOUBLE_BED: '大床',
    TWIN_BED: '双床',
    FREE_CANCEL: '免费取消',
    MEALS: '餐食',
    EVALUATION: '评价',
    FEATURED_REVIEWS: '评价精选',
    ALL_REVIEWS: '全部评价',
    OVERALL_EVALUATION: '总体评价',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '差',
    EVAL_GENERAL_LIST_2: '不好',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '好',
    EVAL_GENERAL_LIST_5: '很好',
    MAX_IMAGES_WITH_NINE: '最多只能选择9张图片!',
    GRADE_EVAL: '请选择总体评价',
    DISTANCE_FILTER: '距离 近→远',
    EDIT_EVALUATION: '写评价',
    GO_TO_EVAL: '去评价',
    EVAL_POINTS_AWARD: '最高可获1000积分(可抵扣10RMB)',
    NEARBY_LIKE_HOTEL: '附近相似酒店',
    DISTANCE_HOTEL: '距离酒店',
    PLEASE_ENTER_COMMENT: '请输入评论内容',
    AWARD_POINTS_TIPS: '评论有机会赢<span>1000积分</span>(可抵扣10RMB)',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名评价不会展示您的头像和昵称',
    LOCATION: '位置',
    FACILITY: '设施',
    SERVICE: '服务',
    HEALTH: '卫生',
    LANGUAGE_SELECT: '语言选择',
    LIMIT_COMMENT_TXT: '评价字数必须在 5~2000 内',
    COLLECTED_SUCCEED: '收藏成功！',
    CANCEL_COLLECT: '已取消收藏！',

    PAY_TEXT1:'支付超时，请重新下单',
    PAY_TEXT2:'余额',
    PAY_TEXT3:'结余',
    PAY_TEXT4:'未开通',
    PAY_TEXT5:'支付附加手续费',
    PAY_TEXT6:'更多',
    PAY_TEXT7:'点击“立即支付”即表示您同意百高',
    PAY_TEXT8:'服务协议',
    PAY_TEXT9:'房费',
    PAY_TEXT10:'联系人',
    PAY_TEXT11:'联系电话',
    PAY_TEXT12:'填写信息',
    PAY_TEXT13:'仅限中国大陆以外地区发行的银行卡',
    PAY_TEXT14:'国际信用卡支付',
    PAY_TEXT15:'其他支付',
    PAY_TEXT16:'请选择支付方式',
    PAY_TEXT17:'使用该支付方式将支付CNY',
    PAY_TEXT18:',你确定使用该支付方式吗?',
    PAY_TEXT19:'支付失败',
  },
  WX_SHARED: {
    DETAIL_TITLE: '|百高酒店预订',
    COMMON_TITLE: '搜索酒店|亚洲数万家酒店在线预订',
    SUB_TITLE: '百高为您提供数万家亚洲酒店在线预订，价格实惠，预订方便！',
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh_cn.js